import { useState, useMemo } from "react";
import { Popover } from "antd";

import { filterCallback } from "@/shared/utils/string";

import { MenuItem } from "../types";

import { PopoverContent } from "./popover-content";

export const SelectMenuPopover = ({
	menuList,
	children,
	popoverWidth,
}: {
	menuList: MenuItem[];
	children: React.ReactNode;
	popoverWidth?: number;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [search, setSearch] = useState<string>("");

	const filteredMenuList = useMemo(
		() => menuList.filter(({ label }) => filterCallback(label, search)),
		[menuList, search]
	);

	const onMenuItemClick = () => {
		setSearch("");
		setIsOpen(false);
	};

	const onOpenChange = (open: boolean) => {
		if (!open) setSearch("");

		setIsOpen(open);
	};

	return (
		<Popover
			content={
				<PopoverContent
					menuList={filteredMenuList}
					search={search}
					setSearch={setSearch}
					onMenuItemClick={onMenuItemClick}
					popoverWidth={popoverWidth}
				/>
			}
			/** Need for set focus on search input */
			destroyTooltipOnHide
			trigger={search.length ? "click" : "hover"}
			open={isOpen}
			onOpenChange={onOpenChange}
			arrow={false}
			placement="bottom"
			rootClassName="[&_.ant-popover-inner]:p-4"
		>
			{children}
		</Popover>
	);
};
